import LoadingNavButton from './LoadingNavButton';

export default LoadingNavButton;
